export const environment = {
  production: false,
  apiUrl: 'https://ms-mb-gateway-ws-nest.apps.dev-bl.kota.mx/api',
  recaptchaSiteKey: '6LfBO_QsAAAAAONd03DJ41urmXC7DnPXPVHoyKZO',
};
